<!-- youtube-mobile-01 / -02 preview — YouTube Shorts ad -->
<app-mobile-frame>
  <!-- START: Shorts player -->
  <div class="yt-s-screen">
    <!-- START: Creative -->
    <ng-container *ngIf="thumbnailUrl; else noThumbnail">
      <!-- A square creative cannot fill a 9:16 screen, so the Shorts player
           backs it with a blurred copy of itself instead of black bars. -->
      <img
        *ngIf="!isFullscreen"
        class="yt-s-backdrop"
        [src]="thumbnailUrl"
        alt=""
        aria-hidden="true"
      />
      <img
        class="yt-s-media"
        [class.yt-s-media-square]="!isFullscreen"
        [src]="thumbnailUrl"
        alt=""
      />
    </ng-container>

    <ng-template #noThumbnail>
      <div class="yt-s-media creative-missing">
        <ng-container *ngIf="isResolving; else askForVideo">
          Reading video formats&hellip;
        </ng-container>
        <ng-template #askForVideo>
          Add a {{ format }} video to see this preview
        </ng-template>
      </div>
    </ng-template>
    <!-- END: Creative -->

    <!-- START: Action rail -->
    <div class="yt-s-actions d-flex flex-column align-items-center">
      <i class="bi bi-hand-thumbs-up"></i>
      <i class="bi bi-hand-thumbs-down"></i>
      <i class="bi bi-chat-fill"></i>
      <i class="bi bi-reply-fill yt-s-share"></i>
    </div>
    <!-- END: Action rail -->

    <!-- START: Ad overlay -->
    <div class="yt-s-overlay">
      <div class="yt-s-advertiser d-flex flex-row align-items-center gap-2">
        <img
          class="yt-s-logo"
          src="assets/images/valamar_logo_80x80.jpg"
          alt=""
        />
        <div class="yt-s-advertiser-text">
          <div class="yt-s-brand">Valamar</div>
          <span class="yt-s-sponsored"><strong>Sponsored</strong></span>
        </div>
      </div>

      <div class="yt-s-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>

      <a
        class="yt-s-cta"
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        >{{ data.ctaText || "Your call to action" }}</a
      >
    </div>
    <!-- END: Ad overlay -->
  </div>
  <!-- END: Shorts player -->

  <app-youtube-mobile-bottom-nav frameBottom></app-youtube-mobile-bottom-nav>
</app-mobile-frame>
